<template>
  <transition name="pop" appear>
    <div class="modal">
      <div class="overlay" @click="closePopup"/>
      <div class="modal-body">
        <div class="modal-content">
          <div class="modal-close" @click="closePopup"/>
          <router-view/>
          <slot/>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Modal',
  methods: {
    goBack() {
      this.$router.push('/')
    },
    closePopup() {
      this.goBack();
      this.$emit('close');
    }
  }
}
</script>